import { useNavigate } from "@solidjs/router";
import SettingsPanel from "./SettingsPanel";

// Route wrapper for /userInfo — everywhere that navigates to a full settings
// page (Movies, search, Series, etc.) keeps working exactly as before.
// The actual settings UI lives in SettingsPanel so it can also be shown
// inline (see Home.tsx, where selecting "Settings" in the header shows it
// without navigating away).
const UserInfo = () => {
  const navigate = useNavigate();

  return <SettingsPanel onEscape={() => navigate(-1)} />;
};

export default UserInfo;
